import { apiClient } from '@/lib/hc'
import { useQuery } from '@tanstack/react-query'

const useErrorPage = () => {
  const results = useQuery({
    queryKey: ['error-page'],
    queryFn: async () => {
      const res = await apiClient.api['error-pages'].error.$get()
      const data = await res.json()
      return data
    },
  })

  return results
}

export default useErrorPage
